<template>
    <el-container>
        <el-aside class="app_aside">
            <div class="app_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <MyAside :asideId="app_asideId"></MyAside>
        </el-aside>
        <el-container>
            <el-header>
                <MyHeader></MyHeader>
            </el-header>
            <div class="app_con">
                <el-aside class="app_CNav">
                    <div class="app_CList">
                        <div class="app_CItem" @click="on_order(1)" :class="on_orderId == 1 ? 'app_CAct' : ''">
                            <div class="app_CIcon">
                                <svg t="1724658984995" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="2564" width="200" height="200">
                                    <path
                                        d="M861.536773 11.238963H165.574011A153.983831 153.983831 0 0 0 11.941398 165.072272v695.762066A154.034005 154.034005 0 0 0 165.574011 1014.717821h695.962762a154.084179 154.084179 0 0 0 153.883483-153.883483V165.072272a154.034005 154.034005 0 0 0-153.883483-153.833309z m73.605174 849.595375a73.705522 73.705522 0 0 1-73.605174 73.655348H165.574011a73.705522 73.705522 0 0 1-73.605174-73.655348V165.072272A73.705522 73.705522 0 0 1 165.574011 91.467098h695.962762a73.705522 73.705522 0 0 1 73.605174 73.605174z"
                                        fill="#999999" p-id="2565"></path>
                                    <path
                                        d="M824.809447 302.699397h-236.519967a40.139154 40.139154 0 0 0 0 80.278309h236.519967a40.139154 40.139154 0 0 0 0-80.278309zM824.809447 590.748003h-236.519967a40.139154 40.139154 0 0 0 0 80.278309h236.519967a40.139154 40.139154 0 0 0 0-80.278309zM428.635994 239.480229L306.964182 361.252389l-39.336371-39.336372A40.139154 40.139154 0 1 0 210.73056 378.512225l67.885345 67.684649a40.139154 40.139154 0 0 0 56.696555 0L485.332549 296.026263a40.139154 40.139154 0 1 0-56.696555-56.696556zM329.743153 503.595865a127.241119 127.241119 0 1 0 127.241119 127.241119 127.241119 127.241119 0 0 0-127.241119-127.241119z m0 174.254103a47.012984 47.012984 0 1 1 47.012984-47.012984 47.063158 47.063158 0 0 1-47.012984 47.012984z"
                                        fill="#999999" p-id="2566"></path>
                                </svg>
                            </div>
                            <span slot="title">帮助中心</span>
                        </div>
                        <div class="app_CItem" @click="on_order(2)" :class="on_orderId == 2 ? 'app_CAct' : ''">
                            <div class="app_CIcon">
                                <svg t="1725005352844" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="6303" width="200" height="200">
                                    <path
                                        d="M514.048 1005.056c-270.848 0-491.52-220.672-491.52-491.52s220.672-491.52 491.52-491.52 491.52 220.672 491.52 491.52-220.672 491.52-491.52 491.52z m0-921.6c-237.056 0-430.08 193.024-430.08 430.08s193.024 430.08 430.08 430.08 430.08-193.024 430.08-430.08-193.024-430.08-430.08-430.08z"
                                        fill="#333333" p-id="6304"></path>
                                    <path
                                        d="M515.072 707.584c-16.896 0-30.72-13.824-30.72-30.72V624.64c0-45.568 33.792-73.728 64-98.304 6.656-5.632 13.824-11.264 19.968-16.896 41.984-37.888 61.44-80.896 51.2-113.152-10.24-30.72-34.816-54.272-68.608-64.512-33.792-10.24-69.632-4.096-93.696 14.848C401.92 391.68 405.504 448 405.504 450.56c1.536 16.896-10.752 31.744-27.648 33.28-16.896 1.536-31.744-11.264-33.28-28.16-0.512-3.584-7.168-90.624 74.752-156.672 39.936-32.256 96.256-41.984 149.504-26.112 53.248 15.872 93.184 53.76 109.568 104.448 17.92 56.32-7.68 122.368-68.608 177.664-7.168 6.656-14.848 12.8-22.016 18.944-26.112 21.504-41.472 35.328-41.472 50.688v51.712c-0.512 17.408-14.336 31.232-31.232 31.232z"
                                        fill="#333333" p-id="6305"></path>
                                    <path
                                        d="M515.072 775.68m-36.864 0a36.864 36.864 0 1 0 73.728 0 36.864 36.864 0 1 0-73.728 0Z"
                                        fill="#333333" p-id="6306"></path>
                                </svg>
                            </div>
                            <span slot="title">常见问题</span>
                        </div>
                        <div class="app_CItem" @click="on_order(3)" :class="on_orderId == 3 ? 'app_CAct' : ''">
                            <div class="app_CIcon">
                                <svg t="1725005393291" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="8202" width="200" height="200">
                                    <path
                                        d="M725.333333 277.333333H393.386667a23.466667 23.466667 0 0 0-23.466667 23.466667 23.466667 23.466667 0 0 0 23.466667 23.466667H725.333333a23.466667 23.466667 0 1 0 0-46.933334z m-426.666666 0a23.893333 23.893333 0 0 0-23.893334 23.466667 23.893333 23.893333 0 0 0 23.893334 23.466667 23.466667 23.466667 0 0 0 23.466666-23.466667A23.466667 23.466667 0 0 0 298.666667 277.333333z m426.666666 140.8H393.386667a23.466667 23.466667 0 0 0-23.466667 23.466667 23.466667 23.466667 0 0 0 23.466667 23.466667H725.333333a23.466667 23.466667 0 0 0 0-46.933334z m-426.666666 0a23.893333 23.893333 0 0 0-23.893334 23.466667 23.893333 23.893333 0 0 0 23.893334 23.466667 23.466667 23.466667 0 0 0 23.466666-23.466667A23.466667 23.466667 0 0 0 298.666667 418.133333z m426.666666 140.8H393.386667a23.466667 23.466667 0 0 0-23.466667 23.466667 23.466667 23.466667 0 0 0 23.466667 23.466667H725.333333a23.466667 23.466667 0 0 0 0-46.933334z m-426.666666 0a23.893333 23.893333 0 0 0-23.893334 23.466667 23.893333 23.893333 0 0 0 23.893334 23.466667 23.466667 23.466667 0 0 0 23.466666-23.466667 23.466667 23.466667 0 0 0-23.466666-23.466667z m426.666666 140.8H393.386667a23.466667 23.466667 0 0 0-23.466667 23.466667 23.466667 23.466667 0 0 0 23.466667 23.466667H725.333333a23.466667 23.466667 0 0 0 0-46.933334z m-426.666666 0a23.893333 23.893333 0 0 0-23.893334 23.466667 23.893333 23.893333 0 0 0 23.893334 23.466667 23.466667 23.466667 0 0 0 23.466666-21.333334 23.466667 23.466667 0 0 0-23.466666-25.6zM820.053333 42.666667H203.946667A118.186667 118.186667 0 0 0 85.333333 160v704A118.186667 118.186667 0 0 0 203.946667 981.333333h616.106666A118.186667 118.186667 0 0 0 938.666667 864V160A118.186667 118.186667 0 0 0 820.053333 42.666667zM144.213333 853.333333V170.666667A68.693333 68.693333 0 0 1 213.333333 101.12h597.333334A68.693333 68.693333 0 0 1 879.786667 170.666667v682.666666A69.12 69.12 0 0 1 810.666667 922.88H213.333333A68.693333 68.693333 0 0 1 144.213333 853.333333z"
                                        fill="#666666" p-id="8203"></path>
                                </svg>
                            </div>
                            <span slot="title">平台规则</span>
                        </div>
                    </div>
                </el-aside>
                <div class="app_Rig">
                    <div class="app_TNav">
                        <div class="app_TList">
                          <div class="app_TItem"
                               v-for="(todo, index) in todos"
                               :class="{ app_TAct: activeTabIndex === index }"
                               @click="switchTab(index)">
                            {{todo.title}} <i class="el-icon-close" @click.stop="removeTodo(index)" v-if="index>0"></i>
                          </div>
                        </div>
                    </div>
                    <el-main>
                        <div class="taskTop">
                            <div class="taskFrom">
                                <el-form ref="taskFrom" :model="taskFrom" label-width=" ">
                                    <el-form-item label="关键词:" class="taskItem">
                                        <el-input v-model="taskFrom.name" placeholder="请输入关键词"></el-input>
                                    </el-form-item>
                                    <div class="taskFBon">
                                        <el-button icon="el-icon-refresh" @click="taskFrom={lx:this.helpIndex};list()">重置</el-button> <el-button
                                            icon="el-icon-search" @click="list">搜索</el-button>
                                    </div>
                                </el-form>
                            </div>
                            <div class="helpList">
                                <div class="helpItem " v-for="(item,index) in helpList" :key="index" :class="helpIndex==item.id?'helpAct':''" @click="to_help(item.id)">
                                    {{item.title }}
                                </div>
                            </div>
                        </div>
                        <div class="taskCon">
                            <div class="helpTable">
                                <el-table :data="helpData" border>
                                    <el-table-column prop="title" label="标题">
                                    </el-table-column>
                                    <el-table-column prop="type" label="所属分类" width="180">
                                    </el-table-column>
                                    <el-table-column prop="addtime" label="发布时间" width="220">
                                    </el-table-column>
                                    <el-table-column prop="lick" label="浏览次数"  width="150">
                                    </el-table-column>
                                    <el-table-column label="操作" width="150">
                                      <template slot-scope="scope"> <!-- 在 Element UI 2.x 中使用 slot-scope -->
                                        <!-- 如果使用 Element UI 3.x+，应使用 v-slot:default="scope" -->
                                        <el-button class="app_mlTableCk" type="text" size="small" @click="heipShowa(scope.row.id)">查看</el-button>
                                      </template>
                                    </el-table-column>
                                </el-table>
                                <div class="app_page">
                                  <el-pagination
                                      @size-change="sizechange"
                                      @current-change="handleCurrentChange"
                                      layout="sizes, prev, pager, next"
                                      :page-sizes="[10,50,80,100]" :page-size="10" :total="pagesize" :current-page="onpage">
                                  </el-pagination>
                                </div>
                            </div>
                        </div>
                        <el-dialog :title="listcon.title" class="helpTan" :visible.sync="heipShow">
                            <div class="helpTkBox" v-html="listcon.con"></div>
                        </el-dialog>
                    </el-main>
                </div>
            </div>
        </el-container>
    </el-container>
</template>

<script>
import axios from "axios";

export default {
    // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
    // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
    name: 'help_center',
    data() {
        return {
            heipShow:false,
            asideId: 2,
            value1: '',
            on_orderId: 1,
            app_asideId: 5,
            helpIndex:0,
            taskFrom: [],
            helpList:[],
            helpData: [],
          listcon: [],
          todos:[],
          onpage:0,
          pagesize:0
        }
    },
    beforeRouteLeave(to, from, next) {
      this.$store.commit('savePageState', {
        pageName: "help_center",
        pageState: {
          taskFrom: this.taskFrom,
          onpage: this.onpage,
          pagesize: this.pagesize
        }
      });
      next();
    },
    // 这里为了测试被切换的组件去哪了
    mounted() {
      this.todos=this.$store.state.tags
      let todos= this.todos
      console.log(this.todos);
      let index =todos.findIndex(note => note.path === "help_center");
      if(index>=0){
        this.activeTabIndex=index
      }else{
        const newNote = {
          title: "帮助中心",
          path: 'help_center'
        }
        this.$store.state.tags.push(newNote);
        this.activeTabIndex=this.todos.length - 1
      }
      this.userpath=this.$store.state.userpath
      this.fetchTableData();
      let savedState = this.$store.state.pageState["help_center"];
      if (savedState) {
        this.taskFrom=savedState.taskFrom
        this.pagesize=savedState.pagesize
        this.onpage=savedState.onpage
        this.handleCurrentChange(this.onpage)
      }
    },
    methods: {
      switchTab(index) {
        this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
      },
      removeTodo(index) {
        this.todos.splice(index, 1);
        this.$forceUpdate();
        if(index==this.activeTabIndex){
          this.$router.push(this.todos[index].path);
        }else if(index<this.activeTabIndex){
          this.activeTabIndex=this.activeTabIndex-1
        }
      },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        on_order(e) {
            console.log('e', e)
            this.on_orderId = e
            if (e == 1) {
                this.$router.push('/help_center')
            } else if (e == 2) {
                this.$router.push('/problem')
            } else if (e == 3) {
                this.$router.push('/platform_rules')
            } 
        },
        to_help(e) {
            console.log('e', e)
            this.helpIndex = e
          this.list()
        },
      fetchTableData(){
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=help')
            .then(response => {
              this.helpData = response.data.arr;
              this.helpList = response.data.lxall;
              this.pagesize = response.data.pagesize;
              this.helpIndex =response.data.lxall[0].id;
              console.log(this.helpIndex)
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      list(){
        this.taskFrom.lx=this.helpIndex
        const formDataa = {
          ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=help', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.helpData = response.data.arr;
                this.helpList = response.data.lxall;
                this.pagesize = response.data.pagesize;
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      sizechange(val){
        this.taskFrom.size = val
        this.taskFrom.page = 0
        const formDataa = {
          ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=help', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.helpData = response.data.arr;
                this.helpList = response.data.lxall;
                this.pagesize = response.data.pagesize;
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      handleCurrentChange(val){
        this.taskFrom.page = val
        const formDataa = {
          ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=help', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.detailData=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      heipShowa(e){
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=help_info&id='+e)
            .then(response => {
              this.listcon = response.data.arr;
              this.heipShow = true;
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      }
    },
}
</script>

<style>
.helpList {
    margin-top: 1px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.helpItem {
    font-size: 14px;
    line-height: 1;
    padding: 12px 20px;
    border: 1px solid rgba(0, 0, 0, .1);
    font-size: 14px;
    border-radius: 8px;
    margin-right: 10px;
    margin-bottom: 10px;
    transition: all 0.48s;
    cursor: pointer;
}

.helpItem:hover {
    color: #ff5000;
}

.helpItem.helpAct {
    background: #ff5000;
    color: #fff;
    border: #ff5000;
}
.helpTable{
    position: relative;
    /* margin-top: 20px; */
}
.helpTable .el-table .el-table__cell:first-child .cell{
    text-align: left;
    padding: 0 20px;
} 
.helpTable .el-button:focus, .helpTable .el-button:hover {
    background: transparent !important;
}
.helpTable .el-table .cell{
    color: #666;
}
.helpTable .el-input__inner {
    border: 1px solid #DCDFE6 !important;
}
.helpTan .el-dialog{
    min-width: 800px;
    width: 70%;
    margin-top: 5% !important;
}
.helpTan .el-dialog__body{
    max-height: 70vh;
    overflow: auto;
}
.helpTan .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
}
.helpTkBox p{
    margin-bottom: 15px;
}
.helpTkBox span{
  font-size: 14px;
}
.helpTkBox img{
    width: 300px;
}
</style>